import { useMutation } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { useEffect } from 'react';

import { showResult } from '../utils';

export interface ISmsCampaignOutcomeData {
  questionGuid: string;
  answers: string[];
  anyAnswer: string | null;
  otherAnswerGuid: string | null;
}

export interface ISmsCampaignOutcomePostData {
  token: string;
  data: ISmsCampaignOutcomeData[];
}

const queryFn = async (postData: ISmsCampaignOutcomePostData) => {
  const url = 'core-2/patients/sms-campaign/outcomes';
  const { data, error } = await dataService.createOne<{ message: 'success' }>(
    url,
    postData,
  );

  if (error) {
    return Promise.reject(error);
  }

  return data;
};

export const useSendCampaignOutcomeData = () => {
  const { mutate, isLoading, error, data, isError } = useMutation<
    { message: 'success' } | undefined,
    string | undefined,
    ISmsCampaignOutcomePostData
  >({
    mutationFn: queryFn,
  });

  useEffect(() => {
    if (error) {
      showResult(error);
    }
  }, [error]);

  return {
    sendCampaignOutcome: mutate,
    isSendLoading: isLoading,
    sendData: data,
    isSendError: isError,
  };
};
